import { get } from 'lodash';
import { APIS } from '../../../../../lib/constants/apis';
import { addIndexesToPath } from '../../../../../utils/helper';

import Schema from '../../../../../lib/paths/antrag_FULL_Paths.json';
const P = Schema.attributes;

type Dependencies = {
	files: any[];
	relations: any[];
};
function SkizzeDependencies(application: any) {
	let dependencies: Dependencies = {
		files: [],
		relations: [],
	};

	const verbundpartner = get(application, P.Verbundpartner.path, []);
	for (let i = 0; i < verbundpartner.length; i++) {
		dependencies.relations.push({
			field: addIndexesToPath(P.Verbundpartner.schema.attributes.Verbundpartner.path, [`${i}`], ['Verbundpartner']),
			api: APIS.Organisation,
		});
	}

	const assoziertepartner = get(application, P.Assoziierte_Partner.path, []);
	for (let i = 0; i < assoziertepartner.length; i++) {
		const eachPartner = assoziertepartner[i];
		const id = get(eachPartner, 'Partner.id', '');
		if (id) {
			dependencies.relations.push({
				field: addIndexesToPath(P.Assoziierte_Partner.schema.attributes.Partner.path, [`${i}`], ['Assoziierte_Partner']),
				api: APIS.Organisation,
			});
		}
	}

	dependencies.relations.push({ field: P.Foerderantrag_Kostenpositions.path, api: APIS.Kostenposition });
	return dependencies;
}
export { SkizzeDependencies };
